import type { ComponentPropsWithRef } from "react";
import { cn } from "@/utils/style.ts";

export type BreadcrumbProps = ComponentPropsWithRef<"nav">;
export function Breadcrumb({ children, className, ...props }: BreadcrumbProps) {
    return (
        <nav {...props} aria-label="Breadcrumb" className={cn("breadcrumb", className)}>
            <ol className="breadcrumb__list">{children}</ol>
        </nav>
    );
}

export type BreadcrumbItemProps = ComponentPropsWithRef<"li">;
export function BreadcrumbItem({ children, className, ...props }: BreadcrumbItemProps) {
    return (
        <li {...props} className={cn("breadcrumb__item", className)}>
            {children}
        </li>
    );
}

export type BreadcrumbLinkProps = ComponentPropsWithRef<"a">;
export function BreadcrumbLink({ children, className, ...props }: BreadcrumbLinkProps) {
    return (
        <BreadcrumbItem>
            <a {...props} className={cn("breadcrumb__link", className)}>
                {children}
            </a>
        </BreadcrumbItem>
    );
}
